import {EuiBasicTable} from '@elastic/eui'
import React from 'react'
import { TypeEuiPropsBasicTable } from 'Type'

const ComponentEuiTableBasic = <T extends object>({columns, items, rowProps, itemId, itemIdToExpandedRowMap, hasActions} :TypeEuiPropsBasicTable<T>) =>
    <EuiBasicTable columns={columns} items={items} hasActions={hasActions} rowProps={rowProps} itemId={itemId} itemIdToExpandedRowMap={itemIdToExpandedRowMap}/>


export default ComponentEuiTableBasic